import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import BmcBlock from './BmcBlock';
import BlockSpecifics from './BlockSpecifics';
import { BMC_BLOCKS } from '../common_components/bmc/bmc_constants';
import { Row, Col, Panel, ButtonToolbar, Button, Glyphicon, Modal } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { leanToBmcBlock, isLeanBlock } from './functions';
import CostStructureForm from './CostStructureForm'
import LeanForm from './LeanForm';
import { LEAN_BLOCKS } from './constants';


@injectIntl
@inject("rootStore")
@observer
export default class GeneralBlockSpecificationStep extends React.Component {

  constructor(props) {
    super(props);

    this.handleCardSelection = this.handleCardSelection.bind(this);
    this.handleAddCard = this.handleAddCard.bind(this);
    this.handleRemoveCard = this.handleRemoveCard.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.state = {
      showModal: false
    }
  }

  render() {
    const { prevPath, nextPath, intl } = this.props;
    const block = this.props.rootStore.igBusinessStore.currentBlock;
    const blockIsLean = isLeanBlock(block);
    let form = null;
    if (block == BMC_BLOCKS.COST_STRUCTURE) {
      form = (
        <Row>
          <Col xs={12}>
            <BmcBlock
              block={block}
              onCardSelection={this.handleCardSelection}
              onlySelectedCards={blockIsLean} />
            <Panel className="full-height-panel border-top-2 border-top">
              <CostStructureForm />
            </Panel>
          </Col>
        </Row>
      );
    }
    else if (blockIsLean) {
      form = (
        <Row>
          <Col xs={12}>
            <Panel className="full-height-panel border-top-2 border-top">
              <LeanForm />
            </Panel>
          </Col>
        </Row>
      );
    }
    else {
      form = (
        <BmcBlock
          block={block}
          onCardSelection={this.handleCardSelection}
          onlySelectedCards={blockIsLean}
        />
      );
    }

    return (
      <div className="general-block-specification-step">
        <Row>
          <Col xs={12}>
            {form}
          </Col>
          <Col xs={12} className="right-child">
            <BlockSpecifics showModal={this.state.showModal} onHideModal={this.hideModal}
              onAddCard={this.handleAddCard} onRemoveCard={this.handleRemoveCard} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="navigation-buttons-container" >
            <div>
              <ButtonToolbar className="bottom-right">
                {prevPath && (
                  <LinkContainer to={prevPath}>
                    <Button ><Glyphicon glyph="arrow-left" />&nbsp; {intl.formatMessage({ id: "previous" })}</Button>
                  </LinkContainer>)}
                {(block == this.props.rootStore.initialBlock) && (
                  <Button onClick={this.handleCancel}>{intl.formatMessage({ id: "cancel" })}</Button>
                )
                }
                {nextPath && (
                  <LinkContainer to={nextPath}>
                    <Button bsStyle="primary" >{intl.formatMessage({ id: "next" })} &nbsp;<Glyphicon glyph="arrow-right" /></Button>
                  </LinkContainer>)}
              </ButtonToolbar>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  handleCardSelection(card) {
    let lastPreselected = this.props.rootStore.activityStore.activityEdit.preselectedCard;
    if (lastPreselected && lastPreselected.preselected) {
      lastPreselected.preselected = false;
    }
    card.preselected = !card.preselected;
    if (card.preselected) {
      this.props.rootStore.activityStore.activityEdit.setPreselectedCard(card);
      this.setState({
        showModal: true
      });
    }
  }

  // Handle block change (next and prev buttons)
  componentWillReceiveProps(nextProps) {
    this.hideModal();
  }

  // Init correctly
  componentWillMount() {
    //this.props.rootStore.setCurrentBlock(this.props.block);
  }

  hideModal() {
    this.setState({
      showModal: false
    })
  }

  handleAddCard(card) {
    let block = this.props.rootStore.igBusinessStore.currentBlock;
    this.props.rootStore.activityStore.activityEdit.addCard(card, block);
    card.selected = true;
    this.hideModal();
  //  console.log("PRFF", this.props.rootStore.newActivityPathPrefix)
    if (block == BMC_BLOCKS.KEY_ACTIVITIES) {
      this.props.history.push(`${this.props.rootStore.newActivityPathPrefix}key_propositions`);
    }
  }

  handleRemoveCard(card) {
    let block = this.props.rootStore.igBusinessStore.currentBlock;
    this.props.rootStore.activityStore.activityEdit.removeCard(card, block);
    card.selected = false;
    this.hideModal();
  }

  handleCancel() {
    this.props.rootStore.activityStore.cancelEditingActivity();
    this.props.history.push(this.props.rootStore.initialPath);
  }

}

function stepTitle(step, intl) {
  let title = undefined;
  title = intl.formatMessage({ id: step + "-title" });
  return title;
}